/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Editor } from "@tiptap/react";
import React from "react";
import ReactTooltip from "react-tooltip";
import { notSelect } from "../../../../styles/general";
import { handleMouseDown } from "./toolbarUtils";

const ToolbarItem = styled.div`
  width: 32px;
  height: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  cursor: pointer;

  border-radius: 4px;

  > svg {
    color: #707070;
  }

  &:hover:not(.active) {
    background: #eaeaea;
  }

  &.active {
    background: #fb972e;

    > svg {
      color: white;
    }
  }
`;

const TooltipText = styled.div`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #ffffff;
`;

const TooltipStyles = css`
  width: fit-content !important;
  padding: 2px 4px !important;
  margin-top: 5px !important;
  ${notSelect}
`;

interface EditToolbarButtonProps {
  children: React.ReactNode;
  tooltipText: string;
  tooltipId: string;
  onClick: () => void;
  editor: Editor;
  isActive?: boolean;
  isOpenDropView?: boolean;
}

export default function EditToolbarButton({
  children,
  tooltipText,
  tooltipId,
  onClick,
  editor,
  isActive = false,
  isOpenDropView = false,
}: EditToolbarButtonProps) {
  return (
    <ToolbarItem
      className={isActive ? "active" : "inactive"}
      onMouseDown={(e) => {
        if (!editor.isFocused) return;
        handleMouseDown(e, onClick);
      }}
      data-tip
      key={tooltipId}
      data-for={tooltipId}
    >
      {children}
      {!isOpenDropView && (
        <ReactTooltip
          id={tooltipId}
          place="bottom"
          effect="solid"
          backgroundColor="#333333"
          arrowColor="transparent"
          css={css`
            ${TooltipStyles} margin-left: 12px !important;
          `}
        >
          <TooltipText>{tooltipText}</TooltipText>
        </ReactTooltip>
      )}
    </ToolbarItem>
  );
}
